import React from 'react';
import { motion } from 'framer-motion';
interface FractionPizzaProps {
  numerator: number;
  denominator: number;
  label?: string;
  type?: 'pizza' | 'chocolate' | 'cake';
  showEaten?: boolean;
  usePizza?: boolean;
}
export function FractionPizza({
  numerator,
  denominator,
  label,
  type = 'pizza',
  showEaten = false,
  usePizza = true
}: FractionPizzaProps) {
  const filledPieces = showEaten ? denominator - numerator : numerator;
  const getEmoji = () => {
    switch (type) {
      case 'pizza':
        return '🍕';
      case 'chocolate':
        return '🍪';
      case 'cake':
        return '🍰';
      default:
        return '🍕';
    }
  };
  const pieces = Array.from({
    length: denominator
  }, (_, i) => i);
  return <div className="bg-[#FFFBEB] rounded-2xl p-5 border border-amber-200 shadow-sm max-w-sm mx-auto" data-id="element-1732">
      {/* Visual Representation */}
      <div className={`
        flex flex-wrap justify-center items-center gap-2 mb-4 mx-auto p-3 min-h-[100px]
        ${usePizza ? 'bg-white/60 rounded-full border border-dashed border-amber-100 max-w-[200px]' : 'bg-transparent max-w-full'}
      `} data-id="element-1733">
        {pieces.map(i => {
        const isFilled = i < filledPieces;
        return <motion.div key={i} initial={{
          scale: 0,
          rotate: -10
        }} animate={{
          scale: 1,
          rotate: 0
        }} transition={{
          delay: i * 0.03
        }} className={`
                aspect-square w-11 h-11 flex items-center justify-center text-2xl
                ${usePizza ? 'rounded-full' : 'rounded-lg'} 
                ${isFilled ? 'bg-white border border-amber-300 shadow-sm' : 'bg-slate-100/50 border border-slate-200 opacity-30'}
              `} data-id="element-1734">
              {isFilled ? getEmoji() : <span className="grayscale opacity-20" data-id="element-1735">{getEmoji()}</span>}
            </motion.div>;
      })}
      </div>

      {/* Compact Info Section */}
      <div className="text-center" data-id="element-1736">
        <div className="inline-flex items-center justify-center gap-3 bg-white/80 rounded-xl px-4 py-2 border border-amber-100 shadow-sm" data-id="element-1737">
          {/* Fraction */}
          <div className="flex flex-col items-center leading-none" data-id="element-1738">
            <span className="text-xl font-black text-amber-600" data-id="element-1739">
              {numerator}
            </span>
            <div className="w-6 h-0.5 bg-slate-300 my-0.5 rounded-full" data-id="element-1740" />
            <span className="text-xl font-black text-slate-700" data-id="element-1741">
              {denominator}
            </span>
          </div>

          <div className="h-8 w-px bg-slate-200" data-id="element-1742" />

          {/* Text Description */}
          <div className="text-left" data-id="element-1743">
            <p className="text-slate-700 text-sm font-medium leading-tight" data-id="element-1744">
              {showEaten ? <>
                  <b data-id="element-1745">{numerator}</b> van de <b data-id="element-1746">{denominator}</b> op
                </> : <>
                  <b data-id="element-1747">{numerator}</b> van de <b data-id="element-1748">{denominator}</b> over
                </>}
            </p>
            {label && <p className="text-slate-500 text-xs italic mt-0.5" data-id="element-1749">{label}</p>}
          </div>
        </div>
      </div>
    </div>;
}